import { useState } from 'react';
import Text from '../../components/Text';
import Input from '../../components/Input';

export default function WebinarSignUp() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    schoolName: '',
    email: '',
    phone: ''
  });

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData(prev => ({
  //     ...prev,
  //     [name]: value
  //   }));
  // };

  const handleSubmit = () => {
    console.log('Form submitted:', formData);
    alert('Thank you! Check your email for the webinar link.');
    setFormData({
      firstName: '',
      lastName: '',
      schoolName: '',
      email: '',
      phone: ''
    });
  };

  return (
    <div className="bg-[#FCFAFF] flex items-center justify-center p-8 md:p-4 border border-[#E2E8F1] rounded-2xl">
      <div className='space-y-8'>
        <div>
          <Text label={"Sign Up & Get Your Webinar Link"} type='cardTitle' cName='font-bold text-2xl' />
          <Text label={"30-min live personalised webinar • Limited seats (verified schools only)"} type='description' cName='text-xs' />
        </div>

        <div className="space-y-6">
          {/* First Name and Last Name Row */}
          <div className="grid grid-cols-2 gap-4">
            <Input label='First Name' />
            <Input label='Last Name' />
          </div>

          {/* School Name */}
          <Input label='School Name' />

          {/* Email Address */}
          <Input label='Email Address' />

          {/* Phone/WhatsApp Number */}
          <Input label='Phone/WhatsApp Number' />

          {/* Submit Button */}
          <button
            onClick={handleSubmit}
            className="w-full py-3 px-4 bg-gradient-to-r from-red-500 to-purple-600 text-[white] font-semibold rounded-lg hover:from-red-600 hover:to-purple-700 transition-all duration-300 shadow-lg"
          >
            Get My Webinar Link
          </button>
        </div>
      </div>
    </div>
  );
}